import React, {useState} from 'react';
import {styles} from './radioButton_styles.web';
import {RadioButtonProps} from './radioButton_types.web';
import InfoIcon from '../../Icons/icons/info';
import {useTheme} from '../../../../utils/theming/themeProvider';
import RadioButtonIcon from '../../Icons/icons/radioButton';
import Tooltip from '../../Tooltips/Tooltip/Tooltip.web';

const RadioButton = (props: React.PropsWithChildren<RadioButtonProps>) => {
  // Props
  const {
    id,
    className,
    state,
    leadingText,
    textColor = 'black',
    size = 'medium',
    textAlign = 'left',
    tooltip,
    containerStyle,
    onClick,
  } = props;

  // Styles
  const [isHovered, setIsHovered] = useState(false);

  const generalStyles = styles();

  const currentState =
    state === 'default' ? (isHovered ? 'hover' : 'default') : state;

  const {colors, fontStyles} = useTheme();
  const font =
    size === 'medium'
      ? fontStyles['bodyRegularMD']
      : fontStyles['bodyRegularSM'];

  return (
    <div
      id={id}
      className={className}
      style={{
        ...generalStyles.radioButtonContainer,
        flexDirection: textAlign === 'right' ? 'row-reverse' : 'row',
        cursor: currentState !== 'disable' ? 'pointer' : 'auto',
        ...containerStyle,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={currentState !== 'disable' ? onClick : undefined}>
      <RadioButtonIcon size={size} colors={colors} state={currentState} />

      {leadingText?.trim()?.length ? (
        <div style={{...generalStyles.radioButtonTextContainer}}>
          <p
            style={{
              ...font,
              lineHeight: font?.lineHeight + 'px',
              margin: 0,
              color:
                textColor === 'black' ? colors.neutral1000 : colors.neutral100,
            }}>
            {leadingText}
          </p>

          {tooltip && (
            <Tooltip {...tooltip}>
              <InfoIcon size={'16'} color={colors.neutral700} />
            </Tooltip>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default RadioButton;
